<template>
    <div class="exercise-solutions-form">
      <div class="add-solution-form" v-if="showSolutionForm">
        <ExerciseSolutionForm
          :solution="localSolution" 
          :onClose="closeSolutionForm"
          @finish-edit-solution="saveSolution"
        />
      </div>
      <div v-if="!showSolutionForm">
        <div class="mt-8 answer" v-for="solution in getCurrentSolutions" :key="solution.id">
          <exercise-solution
            :exercise="exercise"
            :solution="solution"
            :onEdit="editSolution"
            @delete-solution="deleteSolution"
          />
        </div>
      </div>
      <div v-if="!showSolutionForm" class="add-solution-btn flex text-lg mt-10 cursor-pointer" @click.stop="addSolution()"><feather-icon icon="PlusCircleIcon" svgClasses="h-6 w-6" class="mr-4" />
        Add Solution
      </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { solutionFactory } from '@/store/exercise/factories.js'
import ExerciseSolution from './ExerciseSolution'
import ExerciseSolutionForm from './ExerciseSolutionForm'

export default {
  components: {
    ExerciseSolution,
    ExerciseSolutionForm
  },
  props: {
    exercise: Object
  },
  data () {
    return {
      localSolution: {},
      showSolutionForm: false
    }
  },
  computed: {
    ...mapGetters('exercises', ['getCurrentSolutions']),
  },
  methods: {
    ...mapActions('exercises', ['saveSolutionExerciseToApi', 'deleteASolution']),
    async saveSolution(solution) {
      try {
        this.localSolution = {...solution}
        this.$vs.loading()
        await this.saveSolutionExerciseToApi({
          ...this.localSolution
        })
        this.showSolutionForm = false
        this.$vs.notify({
          title: "Success",
          text: 'Solution saved',
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success"
        })
      } catch (error) {
        this.showError(error)
      }
      this.$vs.loading.close()
    },
    async deleteSolution(payload) {
      try {
        this.$vs.loading()
        await this.deleteASolution({
          ...payload,
          deleteFunc: this.$delete
        })
        this.$vs.notify({
          title: "Success",
          text: 'Solution deleted',
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success"
        })
      } catch (error) {
        this.showError(error)
      }
      this.$vs.loading.close()
    },
    addSolution () {
      this.localSolution = {...solutionFactory(this.exercise.id)}
      this.showSolutionForm = true
    },
    editSolution(solution) {
      this.localSolution = {...solution}
      this.showSolutionForm = true
    },
    closeSolutionForm () {
      this.showSolutionForm = false
    }
  },
}
</script>
<style lang="scss" scoped>
  .exercise-solutions-form {
    min-height: 50vh;
  }
  code {
    padding: 0;
  }
</style>